import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useUserRole } from "../../context/UserRoleContext";

const OnboardingRoute = ({ children }) => {
  const { userData, loading, isBarOwner, isArtist, hasCompletedSetup } = useUserRole();
  const location = useLocation();

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner">Loading...</div>
      </div>
    );
  }

  // Enforce onboarding for bar owners
  if (isBarOwner && !hasCompletedSetup) {
    // Don't redirect if already on onboarding page
    if (location.pathname === "/bar-owner/onboarding") {
      return children;
    }

    return <Navigate to="/bar-owner/onboarding" replace />;
  }

  // Enforce onboarding for artists
  if (isArtist && !hasCompletedSetup) {
    // Don't redirect if already on onboarding page
    if (location.pathname === "/artist/onboarding") {
      return children;
    }

    return <Navigate to="/artist/onboarding" replace />;
  }

  // If setup is completed and trying to access onboarding, redirect to dashboard
  if (
    isBarOwner &&
    hasCompletedSetup &&
    location.pathname === "/bar-owner/onboarding"
  ) {
    return <Navigate to="/bar-owner/dashboard" replace />;
  }

  // If setup is completed and trying to access onboarding, redirect to dashboard
  if (
    isArtist &&
    hasCompletedSetup &&
    location.pathname === "/artist/onboarding"
  ) {
    return <Navigate to="/artist" replace />;
  }

  return children;
};

export default OnboardingRoute;
